import {
  PrimitiveValueType,
  RowDataObject,
  RowDataReducerState,
  RowDataReducerAction,
  ErrorState,
} from "../../../../../types";
import { noError } from "../../../validations";

export const checkExpenseAllocationTotalDistributionPercentage = (
  propertyKey: string,
  propertySubKey: string | undefined,
  rowIndex: number | undefined,
  inputValue: PrimitiveValueType | RowDataObject[] | undefined,
  rowDataReducerState: RowDataReducerState,
  dispatch: React.Dispatch<RowDataReducerAction>,
): ErrorState => {
  if (!propertySubKey) return noError();

  const distributionRows = rowDataReducerState.rowData[
    propertyKey
  ] as RowDataObject[];

  const newTotal = Array.isArray(inputValue)
    ? inputValue.reduce((sum, row) => sum + Number(row[propertySubKey] || 0), 0)
    : distributionRows
        .filter((_, index) => index !== rowIndex) // due to sync issue manually filter out the current row and add the new inputValue
        .reduce((sum, row) => sum + Number(row[propertySubKey] || 0), 0) +
      Number(inputValue);

  const validationResult =
    newTotal === 100
      ? noError()
      : {
          error: true,
          message:
            "Total allocation percentage must be exactly 100%. Add accounts or adjust percentage accordingly.",
        };

  distributionRows.forEach((_, index) => {
    dispatch({
      type: "UPDATE_FIELD_VALIDATION",
      payload: {
        propertyKey,
        propertySubKey,
        rowIndex: index,
        newFieldValueValidation: validationResult,
      },
    });
  });

  return validationResult;
};
